/* @flow */
import type { Action } from "../action";

function time(state: number = 0, action: Action): number {
  if (
    action.type === "RECEIVE_SOCKET_MESSAGE" &&
    action.payload.op === "stockPush"
  ) {
    return action.payload.serverTime * 1000;
  }

  return state;
}

export default time;



// WEBPACK FOOTER //
// ./src/redux/reducer/time.js